var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTextBolder = function SvgIconTextBolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5 4.5a1 1 0 0 1 1-1h7.125a4.375 4.375 0 0 1 3.282 7.268 4.75 4.75 0 0 1-2.157 8.982H6a1 1 0 0 1-1-1zm2 7.75v5.5h7.25a2.75 2.75 0 1 0 0-5.5zm6.125-2H7V5.5h6.125a2.375 2.375 0 1 1 0 4.75",
    clipRule: "evenodd"
  })));
};
export default SvgIconTextBolder;